import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Transition as _Transition, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/strengths-mapping/request-landscape-orientation.svg'
import _imports_1 from '../../assets/strengths-mapping/orientation-lock.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-5f59bd3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onKeydown"]
const _hoisted_2 = { class: "rating-interface-wrapper" }
const _hoisted_3 = { class: "rating-interface" }
const _hoisted_4 = { class: "strengths-mapping-navbar hide-on-small-devices" }
const _hoisted_5 = {
  key: 0,
  class: "auto-complete-btn-container"
}
const _hoisted_6 = ["data-test"]
const _hoisted_7 = { "data-test": "strengths-mapping-title" }
const _hoisted_8 = {
  key: 1,
  class: "home-link",
  href: "/",
  "data-test": "strengths-mapping-home-link"
}
const _hoisted_9 = { class: "subnavbar" }
const _hoisted_10 = ["onKeydown"]
const _hoisted_11 = ["data-test"]
const _hoisted_12 = { class: "current-strength" }
const _hoisted_13 = { class: "header subnavbar-header hide-on-small-devices" }
const _hoisted_14 = {
  key: 0,
  class: "header-text",
  "data-test": "sm-strength-progress"
}
const _hoisted_15 = { class: "strength-name strength-name-text" }
const _hoisted_16 = { "data-test": "number-of-rating-items" }
const _hoisted_17 = {
  key: 1,
  class: "header-text"
}
const _hoisted_18 = {
  key: 2,
  class: "header-text"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "page-complete-message"
}
const _hoisted_21 = {
  key: 2,
  class: "page-complete-message"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hide-on-larger-devices" }, [
  /*#__PURE__*/_createElementVNode("b", null, "You've completed the main review."),
  /*#__PURE__*/_createTextVNode(" Flip back through until you're satisfied with the ratings you gave, then continue. ")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hide-on-small-devices" }, " Flip back through the pages until you're satisfied with how they have been placed, then continue. ", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 3,
  class: "page-complete-message"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hide-on-larger-devices" }, [
  /*#__PURE__*/_createElementVNode("b", null, "You've completed the review."),
  /*#__PURE__*/_createTextVNode(" Flip back through until you're satisfied with the ratings you gave, then press submit. ")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hide-on-small-devices" }, " Flip back through the pages until you're satisfied with how the strengths have been placed before submitting. ", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header subnavbar-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "header-text more-information-header-text" }, "More information")
], -1))
const _hoisted_30 = { class: "more-info-checkbox-wrapper" }
const _hoisted_31 = { class: "mobile-submit-button-wrapper hide-on-larger-devices" }
const _hoisted_32 = { class: "mobile-submit-button-inner" }
const _hoisted_33 = ["onKeydown"]
const _hoisted_34 = ["onKeydown"]
const _hoisted_35 = ["onKeydown"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rating-scale" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rating-scale-image" }),
  /*#__PURE__*/_createElementVNode("span", null, "Not characteristic"),
  /*#__PURE__*/_createElementVNode("span", null, "Less characteristic"),
  /*#__PURE__*/_createElementVNode("span", null, "More characteristic"),
  /*#__PURE__*/_createElementVNode("span", null, "Highly characteristic")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "depth-overlay" }, null, -1))
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-menu-left" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-menu-right" }, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 0,
  class: "strength-name-text"
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  key: 0,
  class: "strength-name-text"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-more-info-float" }, null, -1))
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["onKeydown"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay-text" }, "Drag the strengths from the top left corner onto the scale", -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"orientation-overlay\" data-v-5f59bd3d><div class=\"orientation-overlay-text\" data-v-5f59bd3d><img src=\"" + _imports_0 + "\" alt=\"Tilt device to landscape\" data-v-5f59bd3d><span data-v-5f59bd3d>Please turn your device</span><span class=\"inverse\" data-v-5f59bd3d> Make sure that your Orientation Lock <img src=\"" + _imports_1 + "\" alt=\"\" data-v-5f59bd3d> is off </span></div></div><div class=\"unsupported-overlay\" data-v-5f59bd3d><div class=\"unsupported-overlay-text\" data-v-5f59bd3d><span data-v-5f59bd3d>Please try on a larger or more modern device.</span></div></div>", 2)
const _hoisted_54 = {
  key: 0,
  class: "strengths-mapping-interstitial"
}

import { isMobile } from "mobile-device-detect";
import { TweenLite, Power1 } from "gsap";
import Debug from "debug";
import axios from "axios";
import { computed, nextTick, onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import IndicatorProgressModal from "../../components/strengths-mapping/indicator-progress-modal.vue";
import {
  indicatorSteps,
  indicatorProgressionModalContent,
} from "../../components/strengths-mapping/indicator-steps";
import cms from "../../services/cms/cms";
import CmsImg from "../../components/cms/cms-img.vue";
import { csContext } from "../../services/cs-context";
import DraggableStrength from "../../components/strengths-mapping/draggable-strength.vue"; // tslint:disable-line no-var-requires
import StyledCheckbox from "../../components/strengths-mapping/styled-checkbox.vue";
import StrengthsMappingPaging from "../../components/strengths-mapping/strengths-mapping-paging.vue";
import SessionInstanceState from "../../components/sessions/session-instance-state";
import {
  CmsDocumentTypes,
  CmsCustomStrengthMapping,
  CmsCustomStrengthItem,
  CmsImage,
} from "../../services/cms/cms-type-definitions";
import isLiveEnvironment from "../../services/utilities/environment";

const strengthRowGapPercent = 5;

export interface StrengthItemModel {
  ItemId: number;
  DimensionId: number;
  Factor: string;
  Name: string;
  Description: string;
  PositiveIndicators: string[];
  NegativeIndicators: string[];
}

export interface StrengthsMappingModel {
  Id: string;
  IsSelfReview: boolean;
  ViewpointsSubjectFirstName: string | null;
  StrengthItems: StrengthItemModel[];
  Ratings: { [x: string]: number | null };
  CmsCustomStrengthMappingId: string | null;
}

export interface StrengthAndRating {
  strengthId: string;
  cmsCustomStrengthItem?: CmsCustomStrengthItem;
  strengthName: string;
  draggableName: string | null;
  description: string;
  page: number;
  section: 1 | 2;
  rating: number | null;
  order: number;
  positiveIndicators: string[];
  negativeIndicators: string[];
}

export interface PageDetail {
  pageNumber: number;
  isCurrent: boolean;
  isAvailable: boolean;
}

export interface StrengthItemPercentJson {
  Id: string;
  Percent: number;
}

export interface ButtonInfo {
  bigScreenText: string;
  smallScreenText: string;
  action: () => void;
}

export interface CmsMetadata {
  id?: string;
  uid?: string;
  ref?: string;
  type?: string;
  title?: string;
  lastPublished?: string;
}

export type StrengthsMappingType =
  (typeof strengthsMappingTypes)[keyof typeof strengthsMappingTypes];

export interface StrengthMappingMetadata {
  strengthItems: { [x: string]: CmsMetadata };
  questionnaire?: CmsMetadata;
}

export interface StrengthItemsUpdate {
  ratings: { [x: string]: number | null | undefined };
  meta: StrengthMappingMetadata;
  type?: StrengthsMappingType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'strengths-mapping',
  props: {
    model: {},
    embedded: { type: Boolean, default: false },
    numberOfPages: { default: 4 }
  },
  emits: ["submit-review"],
  setup(__props: any, { emit: __emit }) {

const debug = Debug("cs.StrengthsMappingComponent");

const strengthsMappingTypes = {
  strengths: "Strengths",
  indicators: "Indicators",
} as const;

const props = __props;

const route = useRoute();

const firstCustomPageNumber = ref(5);
const currentStrengthItem = ref<StrengthAndRating | null>(null);
const currentPageNumber = ref(1);
const previousPageNumber = ref(1);
const currentStrengthOrderBeforeDragging = ref<number | null>(null);
const currentStrengthRatingBeforeDragging = ref<number | null>(null);
const currentStrengthBeingDragged = ref<StrengthAndRating | null>(null);
const showMoreInfo = ref(false);
const showOverlay = ref(true);
const showInterstitial = ref(false);
const shouldReopenMoreInfo = ref(false);
const isSaving = ref(false);
const hasBeenDestroyed = ref(false);
const ready = ref(false);
const { isAdmin } = csContext.userProfile;
const doc = ref<CmsCustomStrengthMapping | null>(null);
const allStrengthItems = ref<StrengthAndRating[]>([]);

const strengthsMappingType = computed(() => {
  return props.model.StrengthItems.length === 34
    ? strengthsMappingTypes.strengths
    : strengthsMappingTypes.indicators;
});

const maxPageNumber = computed(() => {
  return allStrengthItems.value.length > 0
    ? allStrengthItems.value[allStrengthItems.value.length - 1].page
    : props.numberOfPages;
});

const isMappingIndicators = computed(() => {
  return strengthsMappingType.value === strengthsMappingTypes.indicators;
});

const displayModal = ref(false);

function setShowMoreInfo(value: boolean): void {
  showMoreInfo.value = value;
}

function getCurrentPageStrengths(): StrengthAndRating[] {
  return allStrengthItems.value.filter((item) => item.page === currentPageNumber.value);
}

function getNextUnratedStrengthOnPage(): StrengthAndRating | null {
  return (
    getCurrentPageStrengths()
      .filter((item) => item.rating === null)
      .find(() => true) || null
  );
}

const nextUnratedStrengthOnPage = computed(() => {
  return getNextUnratedStrengthOnPage();
});

const isSection1Complete = computed(() => {
  return !allStrengthItems.value.some((item) => item.rating === null && item.section === 1);
});

const isReviewComplete = computed(() => {
  return !allStrengthItems.value.some((item) => item.rating === null);
});

const shouldDisplaySectionCompleteMessage = computed(() => {
  return (
    currentStrengthItem.value === null &&
    isSection1Complete.value &&
    currentPageNumber.value < firstCustomPageNumber.value &&
    !isReviewComplete.value
  );
});

const shouldDisplayReviewCompleteMessage = computed(() => {
  return currentStrengthItem.value === null && isReviewComplete.value;
});

const shouldDisplayPageCompleteMessage = computed(() => {
  return (
    currentStrengthItem.value === null &&
    nextUnratedStrengthOnPage.value === null &&
    !shouldDisplaySectionCompleteMessage.value &&
    !shouldDisplayReviewCompleteMessage.value
  );
});

const showIndicatorProgressModal = computed(() => {
  return isMappingIndicators.value && shouldDisplayPageCompleteMessage.value;
});

const pageDetails = computed(() => {
  const pageNumbers = [...Array(maxPageNumber.value)].map((x, i) => i + 1);

  const isPart1 = currentPageNumber.value < firstCustomPageNumber.value;
  const isPart2 = !isPart1;

  return pageNumbers.map((pageNumber) => {
    const isPreviousPageAllRated = allStrengthItems.value.every(
      (i) => i.page !== pageNumber - 1 || i.rating !== null,
    );

    return {
      pageNumber,
      isCurrent: pageNumber === currentPageNumber.value,
      isAvailable:
        (pageNumber <= currentPageNumber.value || isPreviousPageAllRated) &&
        ((isPart1 && pageNumber < firstCustomPageNumber.value) ||
          (isPart2 && pageNumber >= firstCustomPageNumber.value)),
    } as PageDetail;
  });
});

const currentPageStrengths = computed(() => {
  return allStrengthItems.value.filter((item) => item.page === currentPageNumber.value);
});

const currentPageVisibleStrengths = computed(() => {
  return currentPageStrengths.value
    .filter((item) => {
      return (
        item.rating !== null ||
        item === nextUnratedStrengthOnPage.value ||
        item === currentStrengthItem.value
      );
    })
    .sort((a, b) => b.order - a.order);
});

const rowHeightPixelsCached = ref<number | undefined>(undefined);

const strengthDragHeightMeasure = ref();
const ratingArea = ref();
const nextUnratedStrengthOrigin = ref();
const currentStrengthLine = ref();
const submitButton = ref();

const emit = __emit;

function rowHeightPixels(): number {
  rowHeightPixelsCached.value =
    rowHeightPixelsCached.value ||
    (strengthDragHeightMeasure.value as HTMLElement).getBoundingClientRect().height *
      (1 + strengthRowGapPercent / 100);
  return rowHeightPixelsCached.value;
}

function positionStrengthInRatingArea(strength: StrengthAndRating, immediate = false) {
  const strengthElement = document.querySelector(
    `[data-strength-id="${strength.strengthId}"]`,
  ) as HTMLElement;

  if (strengthElement && strength.rating !== null) {
    const ratingAreaRect = (ratingArea.value as HTMLElement).getBoundingClientRect();
    const strengthElementRect = strengthElement.getBoundingClientRect();
    const x = ratingAreaRect.width * (strength.rating / 100) - strengthElementRect.width / 2;
    const y = -strength.order * rowHeightPixels();
    const ease = currentStrengthBeingDragged.value ? Power1.easeOut : Power1.easeIn;
    TweenLite.to(strengthElement, immediate ? 0 : 0.2, {
      x,
      y,
      ease,
    });
  }
}

function positionAllRatedStrengths(immediate = false) {
  currentPageVisibleStrengths.value
    .filter((s) => s !== currentStrengthBeingDragged.value && s.rating !== null)
    .forEach((strength) => positionStrengthInRatingArea(strength, immediate));
}

function positionStrengthAsNextUnrated(strength: StrengthAndRating | null, immediate = false) {
  if (strength === null) {
    return;
  }

  const strengthElement = document.querySelector(
    `[data-strength-id="${strength.strengthId}"]`,
  ) as HTMLElement;

  if (strengthElement) {
    const originRect = (nextUnratedStrengthOrigin.value as HTMLElement).getBoundingClientRect();
    const ratingAreaRect = (ratingArea.value as HTMLElement).getBoundingClientRect();
    const x = originRect.left - ratingAreaRect.left;
    const y = originRect.bottom - ratingAreaRect.bottom;
    TweenLite.to(strengthElement, immediate ? 0 : 0.2, { x, y });
  }
}

function positionAllStrengths(immediate = false) {
  positionAllRatedStrengths(immediate);
  if (currentStrengthItem.value && currentStrengthItem.value.rating === null) {
    positionStrengthAsNextUnrated(currentStrengthItem.value, immediate);
  } else if (
    currentStrengthItem.value !== nextUnratedStrengthOnPage.value &&
    nextUnratedStrengthOnPage.value
  ) {
    positionStrengthAsNextUnrated(nextUnratedStrengthOnPage.value, immediate);
  }
}

function resetStrengthOrdersForPage() {
  currentPageStrengths.value
    .sort((a, b) => a.order - b.order)
    .forEach((strength: StrengthAndRating, index: number) => {
      strength.order = index;
    });
}

function initializePage() {
  currentStrengthItem.value = getNextUnratedStrengthOnPage();
  resetStrengthOrdersForPage();
  showMoreInfo.value = false;

  nextTick(() => {
    positionAllStrengths(true);
  });
}

function goToPage(pageNumber: number, force?: boolean): void {
  const pageDetail = pageDetails.value.find((i) => i.pageNumber === pageNumber);
  if (pageDetail && (pageDetail.isAvailable || force)) {
    previousPageNumber.value = currentPageNumber.value;
    currentPageNumber.value = pageNumber;

    nextTick(() => {
      initializePage();
    });
  }
}

function onNextClick(): void {
  displayModal.value = false;
  goToPage(currentPageNumber.value + 1);
}

function toggleIndicatorProgressModal(): void {
  displayModal.value = !displayModal.value;
}

const pageCompleteText = computed(() => {
  if (isMappingIndicators.value) {
    return `You've completed the ${indicatorSteps[currentPageNumber.value - 1].title} section`;
  }
  return `Page ${currentPageNumber.value} of ${maxPageNumber.value} completed`;
});

const ratedStrengthsCount = computed(() => {
  return allStrengthItems.value.filter(
    (item) => item.rating !== null && item !== currentStrengthItem.value,
  ).length;
});

const isSelfReview = computed(() => {
  return props.model.IsSelfReview;
});

const viewpointsSubjectFirstName = computed(() => {
  return props.model.ViewpointsSubjectFirstName;
});

const shouldShowInterstitial = computed(() => {
  return showInterstitial.value;
});

const isSection2 = computed(() => {
  return currentPageNumber.value >= firstCustomPageNumber.value;
});

const maxPageNumberForPaging = computed(() => {
  return isSection2.value || strengthsMappingType.value === strengthsMappingTypes.indicators
    ? maxPageNumber.value
    : firstCustomPageNumber.value - 1;
});

const minPageNumberForPaging = computed(() => {
  return isSection2.value ? firstCustomPageNumber.value : 1;
});

function canGoToPage(pageNumber: number): boolean {
  const pageDetail = pageDetails.value.find((i) => i.pageNumber === pageNumber);
  return !!(pageDetail && pageDetail.isAvailable);
}

const canGoToNextPage = computed(() => {
  return canGoToPage(currentPageNumber.value + 1);
});

const canGoToPreviousPage = computed(() => {
  return canGoToPage(currentPageNumber.value - 1);
});

const reviewTitle = computed(() => {
  if (isSection2.value)
    return cms.asText(
      doc.value?.data.pages[currentPageNumber.value - firstCustomPageNumber.value].page_header,
    );

  if (isMappingIndicators.value) {
    return indicatorSteps[currentPageNumber.value - 1].title;
  }

  return isSelfReview.value
    ? "Strengths Mapping"
    : `Your review of ${viewpointsSubjectFirstName.value}`;
});

function buildStrengthItemsFromModel() {
  const totalStrengthPages = 4;

  const normal = props.model.StrengthItems.map((strength, i) => {
    return {
      strengthId:
        strengthsMappingType.value === strengthsMappingTypes.indicators
          ? strength.ItemId
          : strength.Name,

      strengthName: strength.Name,
      draggableName: strength.Name,
      description: strength.Description,
      page:
        strength.DimensionId <= totalStrengthPages
          ? strength.DimensionId
          : strength.DimensionId - totalStrengthPages,
      rating:
        props.model.Ratings[
          strengthsMappingType.value === strengthsMappingTypes.indicators
            ? strength.ItemId
            : strength.Name
        ] ?? null, // Math.random() * 100,
      order: i,
      section: 1,
      positiveIndicators: strength.PositiveIndicators,
      negativeIndicators: strength.NegativeIndicators,
    } as StrengthAndRating;
  });

  const custom = [] as typeof normal;

  let itemIndex = normal[normal.length - 1].order + 1;

  // if Custom Framework exists
  if (doc.value) {
    let pageNumber = 4;

    doc.value.data.pages.forEach((page) => {
      pageNumber += 1;

      const items = [
        page.item_1_embed_link,
        page.item_2_embed_link,
        page.item_3_embed_link,
        page.item_4_embed_link,
        page.item_5_embed_link,
        page.item_6_embed_link,
        page.item_7_embed_link,
        page.item_8_embed_link,
        page.item_9_embed_link,
        page.item_10_embed_link,
      ];

      items.forEach((item) => {
        if (!item || !item.data) {
          return;
        }

        const id = `custom-id:${item.id}`;

        const rating: StrengthAndRating = {
          strengthId: id,
          cmsCustomStrengthItem: item,
          strengthName: cms.asText(item.data.title),
          draggableName: item.data.draggable_name || cms.asText(item.data.title),
          description: cms.asText(item.data.short_definition).replace(/\u00a0/g, " "),
          page: pageNumber,
          rating: props.model.Ratings[id] ?? null,
          order: itemIndex,
          section: 2,
          positiveIndicators: item.data.positive_indicators.map((ind) =>
            cms.asText(ind.description).replace(/\u00a0/g, " "),
          ),
          negativeIndicators: item.data.negative_indicators.map((ind) =>
            cms.asText(ind.description).replace(/\u00a0/g, " "),
          ),
        };

        custom.push(rating);
        itemIndex += 1;
      });
    });
  }

  return normal.concat(custom).filter((item: StrengthAndRating) => item.page >= 1);
}

function goToFirstIncompletePage() {
  const firstUnfinished = allStrengthItems.value.find(
    (si) => si.rating === null || si.rating === undefined,
  );

  goToPage(firstUnfinished?.page ?? maxPageNumber.value, true);
}

function onResize(event: Event) {
  setTimeout(() => {
    if (!hasBeenDestroyed.value) {
      rowHeightPixelsCached.value = undefined;
      positionAllStrengths(true);
    }
  }, 500);
}

function onKeydown(event: KeyboardEvent): void {
  // TODO: review this, but I think this is weird behaviour and it's triggering when it shouldn't
  // if (event.key === "m") {
  //   showMoreInfo.value = !showMoreInfo.value;
  // }
}

onMounted(() => {
  const begin = () => {
    allStrengthItems.value =
      (props.embedded && SessionInstanceState.get(`allStrengthItems-${props.model.Id}`)) ||
      buildStrengthItemsFromModel();

    goToFirstIncompletePage();
    showOverlay.value = ratedStrengthsCount.value === 0; // Show the overlay if we're starting the review from scratch
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    window.addEventListener("keydown", onKeydown);
    ready.value = true;
  };

  let docPromise: Promise<CmsCustomStrengthMapping> | null = null;

  if (route?.params?.uid && route?.meta?.type === CmsDocumentTypes.CmsCustomStrengthMapping) {
    docPromise = cms.getByUid(
      CmsDocumentTypes.CmsCustomStrengthMapping,
      route?.params.uid as string,
    );
  } else if (props.model.CmsCustomStrengthMappingId) {
    docPromise = cms.getById(
      CmsDocumentTypes.CmsCustomStrengthMapping,
      props.model.CmsCustomStrengthMappingId,
    );
  }

  if (docPromise) {
    docPromise.then((docResult) => {
      doc.value = docResult;
      begin();
    });
  } else {
    begin();
  }
});

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
  window.removeEventListener("orientationchange", onResize);
  window.removeEventListener("keydown", onKeydown);
  if (props.embedded && props.model && props.model.Id && allStrengthItems.value) {
    SessionInstanceState.set(`allStrengthItems-${props.model.Id}`, allStrengthItems.value);
  }
  hasBeenDestroyed.value = true;
});

function saveAndExit(): void {
  // TODO...
}

function nextPage(): void {
  goToPage(currentPageNumber.value + 1);
}

function handleNextArrowClick(): void {
  if (shouldDisplayPageCompleteMessage.value && isMappingIndicators.value) {
    toggleIndicatorProgressModal();
  } else {
    nextPage();
  }
}

function previousPage(): void {
  goToPage(currentPageNumber.value - 1);
}

function onStrengthDragClick(element: HTMLElement, strength: StrengthAndRating): void {
  // Mark this strength as the current one
  currentStrengthItem.value = strength;
}

function hideOverlay(): void {
  showOverlay.value = false;
}

function onStrengthDragStart(element: HTMLElement, strength: StrengthAndRating): void {
  currentStrengthItem.value = strength;
  currentStrengthOrderBeforeDragging.value = strength.order;
  currentStrengthRatingBeforeDragging.value = strength.rating;
  currentStrengthBeingDragged.value = strength;
  if (showMoreInfo.value) {
    shouldReopenMoreInfo.value = true;
  }
  showMoreInfo.value = false;
  hideOverlay();
}

function getCurrentPageVisibleStrengths(): StrengthAndRating[] {
  const nextStrengthOnPage = getNextUnratedStrengthOnPage();
  return getCurrentPageStrengths()
    .filter((item) => {
      return (
        item.rating !== null ||
        (item === nextStrengthOnPage && currentStrengthItem.value === null) ||
        item === currentStrengthItem.value
      );
    })
    .sort((a, b) => b.order - a.order);
}

function getCurrentDraggableRating(strengthElement: HTMLElement): number | null {
  const ratingAreaRect = (ratingArea.value as HTMLElement).getBoundingClientRect();
  const draggableStrengthRect = strengthElement.getBoundingClientRect();
  const draggableRatingOffsetX =
    draggableStrengthRect.left + draggableStrengthRect.width / 2 - ratingAreaRect.left;
  const ratingFraction = draggableRatingOffsetX / ratingAreaRect.width;
  return ratingFraction >= 0 && ratingFraction <= 1 ? ratingFraction * 100 : null;
}

function getCurrentDraggableOrder(strengthElement: HTMLElement): number | null {
  const ratingAreaRect = (ratingArea.value as HTMLElement).getBoundingClientRect();
  const draggableStrengthRect = strengthElement.getBoundingClientRect();
  const draggableOffsetY =
    ratingAreaRect.bottom - draggableStrengthRect.bottom + draggableStrengthRect.height;
  const order = Math.floor(draggableOffsetY / rowHeightPixels());
  const clampedOrder =
    order >= 0 && draggableOffsetY < ratingAreaRect.height
      ? Math.min(order, getCurrentPageVisibleStrengths().length)
      : null;
  return clampedOrder;
}

function positionRatingLine(element: HTMLElement) {
  if (currentStrengthBeingDragged.value) {
    const strengthRect = element.getBoundingClientRect();
    const ratingAreaRect = (ratingArea.value as HTMLElement).getBoundingClientRect();
    const offsetX = strengthRect.left - ratingAreaRect.left + strengthRect.width / 2;
    const offsetY = strengthRect.bottom - ratingAreaRect.top;
    (currentStrengthLine.value as HTMLElement).classList.remove("hidden");
    TweenLite.set(currentStrengthLine.value, {
      left: offsetX,
      top: offsetY,
    });
  }
}

function hideRatingLine() {
  (currentStrengthLine.value as HTMLElement).classList.add("hidden");
  TweenLite.set(currentStrengthLine.value, { top: "100%" });
}

function onStrengthDragMove(element: HTMLElement, strength: StrengthAndRating): void {
  const newRating = getCurrentDraggableRating(element);
  const newOrder = getCurrentDraggableOrder(element);
  if (newRating !== null && newOrder !== null) {
    if (newOrder !== strength.order) {
      // Re-order the strengths
      strength.order = newOrder - 0.5;
      resetStrengthOrdersForPage();
      positionAllRatedStrengths();
    }

    positionRatingLine(element);
  } else {
    hideRatingLine();
  }
}

function saveChanges(): Promise<boolean> {
  if (isSaving.value) {
    // TODO: Queue the request? If the request is ignored like this, data may be lost in exceptional circumstances
    return Promise.resolve(false); // Only one save operation at a time
  }

  const update: StrengthItemsUpdate = {
    ratings: {},
    meta: {
      strengthItems: {},
      questionnaire: doc.value // this is for custom frameworks
        ? {
            id: doc.value.id,
            uid: doc.value.uid,
            ref: cms.getRef(doc.value) || undefined,
            type: doc.value.type,
            title: cms.asText(doc.value.data.title),
            lastPublished: doc.value.last_publication_date,
          }
        : undefined,
    },
    type: strengthsMappingType.value,
  };

  allStrengthItems.value.forEach((sAndR) => {
    if (sAndR) {
      update.ratings[sAndR.strengthId] = sAndR.rating;

      if (sAndR.cmsCustomStrengthItem) {
        update.meta.strengthItems[sAndR.strengthId] = {
          id: sAndR.cmsCustomStrengthItem.id,
          uid: sAndR.cmsCustomStrengthItem.uid,
          ref: cms.getRef(sAndR.cmsCustomStrengthItem) || undefined,
          type: sAndR.cmsCustomStrengthItem.type,
          title: cms.asText(sAndR.cmsCustomStrengthItem.data.title),
          lastPublished: sAndR.cmsCustomStrengthItem.last_publication_date,
        };
      }
    }
  });

  isSaving.value = true;
  return axios
    .post(`/Review/ChangeQuestionnaire/${props.model.Id}`, update)
    .then((e) => {
      isSaving.value = false;
      return true; // Success
    })
    .catch((e) => {
      isSaving.value = false;
      return false; // Failed
    });
}

function onStrengthDragEnd(element: HTMLElement, strength: StrengthAndRating): void {
  const newRating = getCurrentDraggableRating(element);
  const newOrder = getCurrentDraggableOrder(element);
  if (newRating !== null && newOrder != null) {
    strength.rating = newRating;
    strength.order = newOrder;
    saveChanges();
  } else {
    strength.order = (currentStrengthOrderBeforeDragging.value || 0) - 0.5;
    strength.rating = currentStrengthRatingBeforeDragging.value;
  }

  currentStrengthOrderBeforeDragging.value = null;
  currentStrengthRatingBeforeDragging.value = null;
  currentStrengthBeingDragged.value = null;
  currentStrengthItem.value = getNextUnratedStrengthOnPage();
  resetStrengthOrdersForPage();
  hideRatingLine();
  nextTick(() => {
    positionAllRatedStrengths();
    positionStrengthAsNextUnrated(
      currentStrengthItem.value,
      !(currentStrengthItem.value === strength && currentStrengthItem.value.rating === null),
    );
    if (currentStrengthItem.value && shouldReopenMoreInfo.value) {
      showMoreInfo.value = true;
    }
    shouldReopenMoreInfo.value = false;
  });
}

function clearSelected(event: Event): void {
  if (currentStrengthItem.value && currentStrengthItem.value.rating !== null) {
    currentStrengthItem.value = getNextUnratedStrengthOnPage();
    showMoreInfo.value = false;

    if (currentStrengthItem.value) {
      nextTick(() => {
        positionStrengthAsNextUnrated(currentStrengthItem.value, true);
      });
    }
  }
}

async function submitReview(): Promise<void> {
  if (!props.embedded) {
    return saveChanges()
      .then((success) => {
        if (!success) {
          throw new Error("Failed to submit ratings.");
        }
        window.location.href = `/Review/MappingStrengths/${props.model.Id}?completeReport=true`;
      })
      .catch((e) => {
        alert("Failed to submit your review, please try again.");
      });
  }

  return saveChanges()
    .then((success) => {
      if (!success) {
        throw new Error("Failed to submit ratings.");
      }
      return axios
        .get(`/Review/MappingStrengths/${props.model.Id}?completeReport=true`)
        .then((r) => {
          emit("submit-review");
        });
    })
    .catch((e) => {
      alert("Failed to submit your review, please try again.");
    });
}

const interstitialImageSrc = computed(() => {
  return doc?.value?.data?.interstitial_full_size_image;
});

function goToPart2() {
  if (interstitialImageSrc.value?.url) {
    showInterstitial.value = true;
  }
  goToPage(firstCustomPageNumber.value, true);
}

const buttonInfo = computed(() => {
  if (isReviewComplete.value) {
    return {
      bigScreenText: "Submit ratings",
      smallScreenText: "Submit",
      action: () => submitReview(),
    };
  }
  if (isSection1Complete.value && currentPageNumber.value < firstCustomPageNumber.value) {
    return {
      bigScreenText: "Continue",
      smallScreenText: "Continue",
      action: () => goToPart2(),
    };
  }
  if (shouldDisplayPageCompleteMessage.value) {
    return {
      bigScreenText: "Continue",
      smallScreenText: "Continue",
      action: isMappingIndicators.value
        ? () => toggleIndicatorProgressModal()
        : () => goToPage(currentPageNumber.value + 1),
    };
  }
  return {
    bigScreenText: "",
    smallScreenText: "",
    action: () => {
      // Do nothing
    },
  };
});

function hideInterstitial(): void {
  showInterstitial.value = false;
}

function goFullScreen() {
  const elem = document.documentElement as any;
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) {
    /* Firefox */
    elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullscreen) {
    /* Chrome, Safari and Opera */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) {
    /* IE/Edge */
    elem.msRequestFullscreen();
  } else {
    debug("Fullscreen API not supported");
  }
}

// Returns true on success, false otherwise

function autoCompleteStrengthMapping(): void {
  allStrengthItems.value.forEach((item) => {
    item.rating = Math.floor(Math.random() * 100) + 1;
  });
  hideOverlay();
  positionAllRatedStrengths();
  goToFirstIncompletePage();
  saveChanges();
  (submitButton.value as HTMLButtonElement).style.transitionDelay = "1s";
}

return (_ctx: any,_cache: any) => {
  return (ready.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _withModifiers(clearSelected, ["self"]),
        onKeydown: _withKeys(_withModifiers(clearSelected, ["prevent"]), ["space"]),
        class: _normalizeClass([
      'strengths-mapping',
      isMappingIndicators.value ? 'indicator-mapping' : '',
      'current-page-' + currentPageNumber.value,
      'previous-page-' + previousPageNumber.value,
      showOverlay.value ? 'show-overlay' : '',
      showMoreInfo.value ? 'show-more-info' : '',
      currentStrengthItem.value && currentStrengthItem.value.rating == null
        ? 'has-unrated-selected-strength'
        : '',
      !!currentStrengthBeingDragged.value ? 'is-dragging-strength' : '',
      !nextUnratedStrengthOnPage.value ? 'is-page-complete' : '',
      shouldDisplayPageCompleteMessage.value ||
      shouldDisplayReviewCompleteMessage.value ||
      shouldDisplaySectionCompleteMessage.value
        ? 'display-complete-message'
        : '',
      shouldDisplayReviewCompleteMessage.value ||
      shouldDisplaySectionCompleteMessage.value ||
      shouldDisplayPageCompleteMessage.value
        ? 'show-button'
        : '',
      isReviewComplete.value ? 'review-complete' : '',
      isSection2.value ? 'section-2-theme' : '',
      _unref(isMobile) ? 'strengths-mapping-mobile-view' : '',
    ])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!_unref(isLiveEnvironment)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("a", {
                      class: "btn btn-default",
                      id: "auto-complete-btn",
                      href: "javascript:void(0);",
                      "data-test": 
                strengthsMappingType.value === 'Strengths' ? 'auto-complete' : 'indicator-auto-complete'
              ,
                      onClick: autoCompleteStrengthMapping
                    }, "Auto-complete", 8, _hoisted_6)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, [
                _createElementVNode("strong", _hoisted_7, _toDisplayString(reviewTitle.value), 1)
              ]),
              (!_ctx.embedded)
                ? (_openBlock(), _createElementBlock("a", _hoisted_8, "Home"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "drag-start",
                onClick: _withModifiers(clearSelected, ["self"]),
                onKeydown: _withKeys(_withModifiers(clearSelected, ["prevent"]), ["space"])
              }, [
                _createElementVNode("div", {
                  ref_key: "nextUnratedStrengthOrigin",
                  ref: nextUnratedStrengthOrigin,
                  class: "drag-origin-wrapper"
                }, null, 512),
                _createElementVNode("button", {
                  class: "btn btn-lg btn-primary submit-button hide-on-small-devices",
                  ref_key: "submitButton",
                  ref: submitButton,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (buttonInfo.value.action())),
                  "data-test": 
                strengthsMappingType.value === 'Strengths'
                  ? 'screen-lg-submit'
                  : 'screen-lg-indicator-submit'
              ,
                  type: "button"
                }, _toDisplayString(buttonInfo.value.bigScreenText), 9, _hoisted_11),
                _createVNode(StrengthsMappingPaging, {
                  class: "mobile-paging hide-on-larger-devices",
                  "current-page-number": currentPageNumber.value,
                  "min-page-number": minPageNumberForPaging.value,
                  "max-page-number": maxPageNumber.value,
                  "max-accessible-page-number": maxPageNumberForPaging.value,
                  onPreviousPage: previousPage,
                  onNextPage: nextPage,
                  onGoToPage: goToPage,
                  "can-go-to-previous-page": canGoToPreviousPage.value,
                  "can-go-to-next-page": canGoToNextPage.value,
                  "page-details": pageDetails.value.slice(minPageNumberForPaging.value - 1, maxPageNumberForPaging.value)
                }, null, 8, ["current-page-number", "min-page-number", "max-page-number", "max-accessible-page-number", "can-go-to-previous-page", "can-go-to-next-page", "page-details"])
              ], 40, _hoisted_10),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (currentStrengthItem.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(currentStrengthItem.value.strengthName), 1),
                        _createTextVNode(" (" + _toDisplayString(ratedStrengthsCount.value + 1) + "/", 1),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(allStrengthItems.value.length), 1),
                        _createTextVNode(") ")
                      ]))
                    : _createCommentVNode("", true),
                  (shouldDisplayPageCompleteMessage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(pageCompleteText.value), 1))
                    : _createCommentVNode("", true),
                  (shouldDisplaySectionCompleteMessage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, " You've completed the main review. "))
                    : _createCommentVNode("", true)
                ]),
                (currentStrengthItem.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(currentStrengthItem.value.description), 1))
                  : _createCommentVNode("", true),
                (shouldDisplayPageCompleteMessage.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, " You're done with this page. You can still move the " + _toDisplayString(strengthsMappingType.value === "Strengths" ? "strengths" : "items") + ", or click on them to review the definition. ", 1))
                  : _createCommentVNode("", true),
                (shouldDisplaySectionCompleteMessage.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, _hoisted_24))
                  : _createCommentVNode("", true),
                (shouldDisplayReviewCompleteMessage.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_25, _hoisted_28))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "current-strength-more-info hover-wrapper",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showMoreInfo.value = !showMoreInfo.value)),
                  onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (showMoreInfo.value = !showMoreInfo.value), ["prevent"]), ["space"]))
                }, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(StyledCheckbox, {
                      modelValue: showMoreInfo.value,
                      "onUpdate:modelValue": setShowMoreInfo
                    }, null, 8, ["modelValue"])
                  ])
                ], 32),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary mobile-submit-button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (buttonInfo.value.action())),
                      "data-test": "screen-sm-submit",
                      type: "button"
                    }, _toDisplayString(buttonInfo.value.smallScreenText), 1)
                  ])
                ])
              ]),
              _createVNode(StrengthsMappingPaging, {
                class: "hide-on-small-devices",
                "current-page-number": currentPageNumber.value,
                "min-page-number": minPageNumberForPaging.value,
                "max-page-number": maxPageNumber.value,
                "max-accessible-page-number": maxPageNumberForPaging.value,
                onPreviousPage: previousPage,
                onNextPage: nextPage,
                onGoToPage: goToPage,
                "can-go-to-previous-page": canGoToPreviousPage.value,
                "can-go-to-next-page": canGoToNextPage.value,
                "page-details": pageDetails.value.slice(minPageNumberForPaging.value - 1, maxPageNumberForPaging.value)
              }, null, 8, ["current-page-number", "min-page-number", "max-page-number", "max-accessible-page-number", "can-go-to-previous-page", "can-go-to-next-page", "page-details"])
            ]),
            _createElementVNode("div", {
              class: "main-area",
              onClick: _withModifiers(clearSelected, ["self"]),
              onKeydown: _withKeys(_withModifiers(clearSelected, ["prevent"]), ["space"])
            }, [
              _createElementVNode("div", {
                class: "rating-area",
                onClick: _withModifiers(clearSelected, ["self"]),
                onKeydown: _withKeys(_withModifiers(clearSelected, ["prevent"]), ["space"]),
                "data-test": "rating-area"
              }, [
                _createElementVNode("div", {
                  ref_key: "strengthDragHeightMeasure",
                  ref: strengthDragHeightMeasure,
                  class: "strength-drag-height-measure"
                }, null, 512),
                _createElementVNode("div", {
                  ref_key: "currentStrengthLine",
                  ref: currentStrengthLine,
                  class: "current-strength-line hidden"
                }, null, 512),
                _createElementVNode("div", {
                  ref_key: "ratingArea",
                  ref: ratingArea,
                  class: "ratings",
                  onClick: _withModifiers(clearSelected, ["self"]),
                  onKeydown: _withKeys(_withModifiers(clearSelected, ["prevent"]), ["space"])
                }, [
                  _createVNode(_TransitionGroup, {
                    name: "transition-strengths",
                    tag: "div"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentPageVisibleStrengths.value, (item) => {
                        return (_openBlock(), _createBlock(DraggableStrength, {
                          key: item.strengthId,
                          "data-strength-id": item.strengthId,
                          strength: item,
                          "is-current": item === currentStrengthItem.value,
                          onDragClick: onStrengthDragClick,
                          onDragStart: onStrengthDragStart,
                          onDragMove: onStrengthDragMove,
                          onDragEnd: onStrengthDragEnd,
                          class: _normalizeClass('strength-on-page-' + currentPageNumber.value)
                        }, null, 8, ["data-strength-id", "strength", "is-current", "class"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ], 40, _hoisted_35),
                _hoisted_36,
                _hoisted_37,
                _createElementVNode("a", {
                  class: "nav-arrow previous-nav-arrow",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (previousPage())),
                  onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (previousPage()), ["prevent"]), ["enter"])),
                  disabled: !canGoToPreviousPage.value,
                  "aria-label": "Previous page"
                }, _hoisted_40, 40, _hoisted_38),
                _createElementVNode("a", {
                  class: "nav-arrow next-nav-arrow",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (handleNextArrowClick())),
                  onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (handleNextArrowClick()), ["prevent"]), ["enter"])),
                  disabled: !canGoToNextPage.value,
                  "aria-label": "Next page"
                }, _hoisted_43, 40, _hoisted_41)
              ], 40, _hoisted_34),
              _createVNode(_Transition, { name: "left-shutter-transition" }, {
                default: _withCtx(() => [
                  (showMoreInfo.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "shutter left-shutter",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (showMoreInfo.value = false)),
                        onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (showMoreInfo.value && showMoreInfo.value(...args)), ["prevent"]), ["space"]))
                      }, [
                        _createElementVNode("h4", null, [
                          _createTextVNode(" Less characteristic of "),
                          (currentStrengthItem.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(currentStrengthItem.value.strengthName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (currentStrengthItem.value)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_45, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentStrengthItem.value.negativeIndicators, (indicator, i) => {
                                return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(indicator), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 32))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "right-shutter-transition" }, {
                default: _withCtx(() => [
                  (showMoreInfo.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "shutter right-shutter",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (showMoreInfo.value = false)),
                        onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (showMoreInfo.value && showMoreInfo.value(...args)), ["prevent"]), ["space"]))
                      }, [
                        _createElementVNode("h4", null, [
                          _createTextVNode(" More characteristic of "),
                          (currentStrengthItem.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(currentStrengthItem.value.strengthName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_47,
                        (currentStrengthItem.value)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_48, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentStrengthItem.value.positiveIndicators, (indicator, i) => {
                                return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(indicator), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 32))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 40, _hoisted_33),
            _createElementVNode("div", {
              class: "overlay",
              onClick: _withModifiers(hideOverlay, ["self"]),
              onKeydown: _withKeys(_withModifiers(hideOverlay, ["self"]), ["space"])
            }, _hoisted_51, 40, _hoisted_49)
          ])
        ]),
        _hoisted_52,
        (shouldShowInterstitial.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
              _createVNode(CmsImg, {
                src: interstitialImageSrc.value,
                class: "strengths-mapping-interstitial-image"
              }, null, 8, ["src"]),
              _createElementVNode("button", {
                class: "strengths-mapping-interstitial-button btn btn-lg btn-primary",
                onClick: hideInterstitial,
                type: "button"
              }, " Next ")
            ]))
          : _createCommentVNode("", true),
        (displayModal.value)
          ? (_openBlock(), _createBlock(IndicatorProgressModal, {
              key: 1,
              "show-modal": displayModal.value,
              "modal-title": _unref(indicatorProgressionModalContent)[currentPageNumber.value - 1].title,
              "modal-message": _unref(indicatorProgressionModalContent)[currentPageNumber.value - 1].message,
              "current-step": currentPageNumber.value,
              steps: _unref(indicatorSteps),
              onOnNextClick: onNextClick
            }, null, 8, ["show-modal", "modal-title", "modal-message", "current-step", "steps"]))
          : _createCommentVNode("", true)
      ], 42, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})